import { render, staticRenderFns } from "./StatusSolicitacao.vue?vue&type=template&id=27c7f866&scoped=true"
import script from "./StatusSolicitacao.vue?vue&type=script&lang=js"
export * from "./StatusSolicitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c7f866",
  null
  
)

export default component.exports